import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

type OrderMeta = {
  table: number | null;
  persons: number | null;
  setTable: (n: number) => void;
  setPersons: (n: number) => void;
  setBoth: (table: number, persons: number) => void;
  reset: () => void;
};

export const useOrder = create<OrderMeta>()(
  persist(
    (set) => ({
      table: null,
      persons: null,
      setTable: (n) => set({ table: n }),
      setPersons: (n) => set({ persons: n }),
      setBoth: (table, persons) => set({ table, persons }),
      reset: () => set({ table: null, persons: null }),
    }),
    { name: "order-meta:v1", storage: createJSONStorage(() => localStorage) }
  )
);
